import angular from 'angular';
import '../components/tree';
import '../controllers/modals/new-segment';
import '../services/organization-segment';
import '../services/segments';
import '../services/notifications';

const module = angular.module('whyline.controllers.segments', [
  'whyline.components.tree',
  'whyline.modals.new-segment',
  'whyline.services.organization-sector',
  'whyline.services.sector',
  'whyline.services.notifications',
  'whyline.services.segment',
]);

const SegmentsController = ($scope, $state, $uibModal, OrganizationSegmentService, dialog, $translate, NotificationService, SegmentService) => {
  $scope.placeId = $state.params.placeId ? $state.params.placeId : false;
  $scope.fromSegments = true;
  $scope.segments = SegmentService.GetAll();

  $scope.savePlaceSegment = () => {
    $scope.$broadcast('save-place-segments');
  };

  $scope.switch = segment => {
    let enabled = !segment.enabled;

      SegmentService.Switch(segment, enabled).then(() => {
        NotificationService.Success($translate.instant('organization_segment_updated_succ'));
      })
  };

  // Modal
  $scope.open = segmentId => {
    $uibModal.open({
      templateUrl: '/templates/components/modals/new-segment-modal.html',
      size: 'lg',
      controller: 'SegmentModalController',
      resolve: {
        fromSegments: () => true,
        segmentId: () => segmentId,
      },
    });
  };
};

module.exports = module.controller('SegmentsController', SegmentsController);
